import { ApiService } from '@b2b/common/services/api/types';
import { clearFieldValues } from '@b2b/common/services/helpers';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core/utils';
import angular from 'angular';

export const ResourceFieldEditDirectiveModule = angular
  .module('acme.common.directive.resourceFieldEdit', [
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
  ])
  .directive('resourceFieldEdit', [
    'ApiService',
    'PermissionsService',
    'HelpersService',
    function ResourceFieldEditDirective(
      ApiService: ApiService,
      PermissionsService: PermissionsService,
      HelpersService: TODO
    ) {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/resourceField/edit/edit.tpl.html',
        scope: {
          field: '=',
          entity: '=',
          fieldIndex: '@fieldindex',
          resourceTemplateId: '@resourcetemplateid',
          disableEdit: '@disableedit',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ResourceFieldEditController($scope) {
            $scope.resourceFieldEdit = {
              init: function () {
                angular.copy($scope.field, this.field);
                this.defaultValue = HelpersService.getFieldValue(this.field);
                this.defaultType = HelpersService.getFieldType(this.field).simpleType;
                $scope.$on('ResourcesCreateController::complete', this.onResourcesCreateControllerComplete);
                $scope.$on('ResourcesEditController::complete', this.onResourcesCreateControllerComplete);
                console.log(this.defaultValue, $scope.field);
              },

              field: {},
              fieldTypes: [
                { title: 'String', name: 'string' },
                { title: 'Number', name: 'number' },
              ],

              defaultValue: '',
              defaultType: 'string',

              isValueValid: true,
              invalidMessage: '',

              isNameValid: true,
              nameInvalidMessage: 'Name is required',

              parseValue: function () {
                var parsed;

                // Parse and clear out other values
                parsed = HelpersService.parseValueType(this.defaultType, this.defaultValue, true);
                this.field = clearFieldValues(this.field);

                if (parsed) {
                  this.isValueValid = true;
                  if (this.field.hasOwnProperty(parsed.key)) {
                    this.field.type = parsed.type;
                    this.field[parsed.key] = parsed.value;
                    this.defaultType = parsed.simpleType;
                  }
                }

                console.log('resourceFieldEdit::parseValue', parsed);

                return parsed;
              },

              cancel: function () {},

              remove: function () {
                $scope.$emit('resourceFieldEdit::remove', { field: $scope.field, index: $scope.fieldIndex });
              },

              save: function () {
                this.isNameValid = this.field.name.length > 0;
                this.isValueValid = this.parseValue();

                console.log('save: ', this.isNameValid, this.isValueValid);
                if (this.isNameValid === false) {
                  // Don't continue there were issues
                  return;
                }

                if (this.isValueValid === false) {
                  this.invalidMessage = HelpersService.errors[0].message;
                  // Don't continue there were issues
                  return;
                }

                angular.copy(this.field, $scope.field);

                if ($scope.resourceTemplateId && $scope.resourceTemplateId != -1) {
                  console.log('resourceFieldCreate', $scope.resourceTemplateId);
                  if (PermissionsService.check('ENTITY_TEMPLATE_' + $scope.entity.singular.toUpperCase() + '_UPDATE')) {
                    ApiService.resource.field
                      .create($scope.field, $scope.resourceTemplateId)
                      .then(this.success, this.error);
                  } else {
                    $scope.$emit('Permissions::error');
                  }
                }
              },

              onResourcesCreateControllerComplete: function (e, data) {
                $scope.resourceFieldEdit.isNameValid = $scope.resourceFieldEdit.field.name.length > 0;
                $scope.resourceFieldEdit.isValueValid = $scope.resourceFieldEdit.parseValue();

                console.log('$scope.resourceFieldEdit.isNameValid', $scope.resourceFieldEdit.isNameValid);
                console.log('$scope.resourceFieldEdit.isValueValid', $scope.resourceFieldEdit.isValueValid);

                if ($scope.resourceFieldEdit.isNameValid === false) {
                  console.log('$scope.resourceFieldEdit.isNameValid', $scope.resourceFieldEdit.isNameValid);
                  // Don't continue there were issues
                  return;
                }

                if ($scope.resourceFieldEdit.isValueValid === false) {
                  console.log(
                    '$scope.resourceFieldEdit.isValueValid',
                    HelpersService.errors,
                    $scope.resourceFieldEdit.isValueValid
                  );

                  $scope.resourceFieldEdit.invalidMessage = HelpersService.errors[0].message;
                  // Don't continue there were issues
                  return;
                }

                console.log('$scope.resourceFieldEdit.field', $scope.resourceFieldEdit.field, $scope.field);

                angular.copy($scope.resourceFieldEdit.field, $scope.field);
                if (data && data.hasOwnProperty('callback') && typeof data.callback === 'function') {
                  data.callback();
                }
              },
            };

            $scope.resourceFieldEdit.init();
          },
        ],
      };
    },
  ]).name;
